(function () {
  'use strict';

  /* ── Reduce-motion guard ──────────────────────────── */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ── Helpers ──────────────────────────────────────── */
  function markReveal(el, delay) {
    el.classList.add('wdw-reveal');
    if (delay) el.style.setProperty('--wdw-delay', delay + 'ms');
  }

  function stagger(selector, stepMs) {
    document.querySelectorAll(selector).forEach(function (el, i) {
      markReveal(el, i * stepMs);
    });
  }

  /* ── Mark elements for scroll reveal ─────────────── */
  function markAll() {

    /* Section heads – eyebrows, titles, subtitles */
    var headSelectors = [
      '.wdw-eyebrow',
      '.audit-grid__title', '.audit-grid__sub',
      '.pricing__title',    '.pricing__sub',
      '.tmnls__title',
      '.cases__title',      '.cases__sub',
      '.two-phase__title',  '.two-phase__sub',
      '.timeline-s__title',
      '.logo-bar__title',
      '.finalcta__title',   '.finalcta__sub', '.finalcta__btn',
      '.collapsible-content__heading',
    ];
    document.querySelectorAll(headSelectors.join(',')).forEach(function (el) {
      markReveal(el, 0);
    });

    /* Card grids – staggered per group */
    stagger('.audit-card',       90);
    stagger('.plan',             110);
    stagger('.tmnls__card',       90);
    stagger('.case',             130);
    stagger('.two-phase__card',  140);
    stagger('.timeline-s__step',  90);
    stagger('.logo-bar__item',    55);
  }

  /* ── IntersectionObserver – scroll reveal ─────────── */
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.wdw-reveal').forEach(function (el) {
        el.classList.add('wdw-visible');
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('wdw-visible');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -48px 0px' });

    document.querySelectorAll('.wdw-reveal').forEach(function (el) {
      io.observe(el);
    });
  }

  /* ── Counter animation for case metrics ──────────── */
  function initCounters() {
    if (!('IntersectionObserver' in window)) return;

    var counterIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        counterIO.unobserve(entry.target);

        var el    = entry.target;
        var raw   = el.getAttribute('data-raw') || el.textContent.trim();
        el.setAttribute('data-raw', raw);

        var match = raw.match(/^([^0-9]*)([0-9]+(?:\.[0-9]+)?)(.*)$/);
        if (!match) return;

        var prefix   = match[1];
        var target   = parseFloat(match[2]);
        var suffix   = match[3];
        var duration = 1400;
        var start    = null;

        function tick(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased    = 1 - Math.pow(1 - progress, 3);
          el.textContent = prefix + Math.round(target * eased) + suffix;
          if (progress < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.6 });

    document.querySelectorAll('.case__metric').forEach(function (el) {
      counterIO.observe(el);
    });
  }

  /* ── Init ─────────────────────────────────────────── */
  function init() {
    markAll();
    initScrollReveal();
    initCounters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
